var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end" },
              [
                _c(
                  "b-modal",
                  {
                    ref: "addProjectModal",
                    attrs: {
                      id: "modal-add-project",
                      "ok-only": "",
                      "ok-title": "Add",
                      centered: "",
                      size: "lg",
                      title: "Add Project",
                      "hide-footer": true,
                      "no-close-on-backdrop": "",
                      "no-close-on-esc": "",
                    },
                  },
                  [
                    _c("Addproject", {
                      attrs: { assignee: _vm.assignee_options },
                      on: {
                        projectAdded: _vm.closeAddProjectModal,
                        refresh: _vm.refreshData,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.modal-add-project",
                        modifiers: { "modal-add-project": true },
                      },
                    ],
                    attrs: { variant: "primary" },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "PlusIcon" },
                    }),
                    _vm._v(" Add Project "),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm.projects.length === 0 && !_vm.docloading
        ? _c(
            "div",
            [
              _c(
                "b-row",
                { staticClass: "justify-content-center mt-3" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-card",
                        [
                          _c("b-card-body", { staticClass: "text-center" }, [
                            _c("h2", [_vm._v("No projects available")]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-block" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-between" },
            [
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { col: "12", md: "2", sm: "2" } },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "label",
                        { staticClass: "d-inline-block text-sm-left mr-50" },
                        [_vm._v("Per page")]
                      ),
                      _c("b-form-select", {
                        attrs: {
                          id: "perPageSelect",
                          size: "sm",
                          options: _vm.pageOptions,
                        },
                        model: {
                          value: _vm.perPage,
                          callback: function ($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-end mb-2",
                  staticStyle: { position: "relative", "z-index": "1" },
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-danger" },
                      on: { click: _vm.clearFilters },
                    },
                    [_vm._v(" Clear Filters ")]
                  ),
                ],
                1
              ),
              !_vm.loading
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.filteredProjects,
                          fields: _vm.fields,
                        },
                        on: { filtered: _vm.onFiltered },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "head(name)",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c("span", [_vm._v("Project Name *")]),
                                      _c("b-form-input", {
                                        attrs: {
                                          placeholder: "Filter by Project Name",
                                          size: "sm",
                                        },
                                        on: { input: _vm.filterTable },
                                        model: {
                                          value: _vm.columnFilters.projectName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.columnFilters,
                                              "projectName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "columnFilters.projectName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "head(Approver)",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c("span", [_vm._v("Approver")]),
                                      _c("b-form-input", {
                                        attrs: {
                                          placeholder: "Filter by Approver",
                                          size: "sm",
                                        },
                                        on: { input: _vm.filterTable },
                                        model: {
                                          value: _vm.columnFilters.approver,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.columnFilters,
                                              "approver",
                                              $$v
                                            )
                                          },
                                          expression: "columnFilters.approver",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "head(progress)",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c("span", [_vm._v("Progress")]),
                                      _c(
                                        "b-form-select",
                                        {
                                          attrs: {
                                            options: _vm.progressOptions,
                                            size: "sm",
                                          },
                                          on: { change: _vm.filterTable },
                                          model: {
                                            value: _vm.columnFilters.progress,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.columnFilters,
                                                "progress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "columnFilters.progress",
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [_vm._v("All")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "head(status)",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c("span", [_vm._v("Status")]),
                                      _c(
                                        "b-form-select",
                                        {
                                          attrs: {
                                            options: _vm.statusOptions,
                                            size: "sm",
                                          },
                                          on: { change: _vm.filterTable },
                                          model: {
                                            value: _vm.columnFilters.status,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.columnFilters,
                                                "status",
                                                $$v
                                              )
                                            },
                                            expression: "columnFilters.status",
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [_vm._v("All")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "head(priority)",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex flex-column" },
                                    [
                                      _c("span", [_vm._v("Priority")]),
                                      _c(
                                        "b-form-select",
                                        {
                                          attrs: {
                                            options: _vm.priorityOptions,
                                            size: "sm",
                                          },
                                          on: { change: _vm.filterTable },
                                          model: {
                                            value: _vm.columnFilters.priority,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.columnFilters,
                                                "priority",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "columnFilters.priority",
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { domProps: { value: null } },
                                            [_vm._v("All")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "cell(progress)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "b-badge",
                                    {
                                      attrs: {
                                        variant:
                                          _vm.progressMap[data.item.progress]
                                            .variant,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.progressMap[data.item.progress]
                                              .text
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(Approver)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getApproverName(
                                              data.item.approverId
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(status)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "b-badge",
                                    {
                                      attrs: {
                                        variant:
                                          _vm.statusMap[data.item.status]
                                            .variant,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.statusMap[data.item.status].text
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(priority)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "b-badge",
                                    {
                                      attrs: {
                                        variant:
                                          _vm.priorityMap[data.item.priority]
                                            .variant,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.priorityMap[data.item.priority]
                                              .text
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(actions)",
                              fn: function (data) {
                                return [
                                  _c(
                                    "b-dropdown",
                                    {
                                      staticClass: "m-1",
                                      attrs: {
                                        variant: "link",
                                        "toggle-class": "p-0",
                                        "no-caret": "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "button-content",
                                            fn: function () {
                                              return [
                                                _c("feather-icon", {
                                                  staticClass:
                                                    "align-middle text-body",
                                                  attrs: {
                                                    icon: "MoreVerticalIcon",
                                                    size: "16",
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      data.item.status === "NOTSTARTED" &&
                                      data.item.approverId === _vm.userId
                                        ? _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changeProjectStatus(
                                                    data.item,
                                                    "APPROVED"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "CheckIcon" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-50",
                                                },
                                                [_vm._v("Approve")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      data.item.status === "NOTSTARTED" &&
                                      data.item.approverId === _vm.userId
                                        ? _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changeProjectStatus(
                                                    data.item,
                                                    "REMOVED"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "XIcon" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-50",
                                                },
                                                [_vm._v("Reject")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "b-dropdown-item",
                                        {
                                          attrs: {
                                            to: {
                                              name: "view-project",
                                              params: {
                                                id: data.item.projectId,
                                              },
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: { icon: "EyeIcon" },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "align-middle ml-50",
                                            },
                                            [_vm._v("View")]
                                          ),
                                        ],
                                        1
                                      ),
                                      data.item.status === "NOTSTARTED"
                                        ? _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteProject(
                                                    data.item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "TrashIcon" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-50",
                                                },
                                                [_vm._v("Delete")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      data.item.status !== "NOTSTARTED" &&
                                      data.item.status !== "REMOVED"
                                        ? _c(
                                            "b-dropdown-item",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "milestones-list",
                                                  params: {
                                                    id: data.item.projectId,
                                                  },
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "FlagIcon" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-50",
                                                },
                                                [_vm._v("Milestones")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      data.item.status !== "NOTSTARTED" &&
                                      data.item.status !== "REMOVED"
                                        ? _c(
                                            "b-dropdown-item",
                                            {
                                              attrs: {
                                                to: {
                                                  path:
                                                    "/projectmanagement/tasks-list/" +
                                                    data.item.projectId,
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "FileTextIcon" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-50",
                                                },
                                                [_vm._v("Tasks")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      data.item.status !== "NOTSTARTED" &&
                                      data.item.status !== "REMOVED"
                                        ? _c(
                                            "b-dropdown-item",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "project-ganttchart",
                                                  params: {
                                                    id: data.item.projectId,
                                                  },
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: {
                                                  icon: "BarChart2Icon",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-50",
                                                },
                                                [_vm._v("Gantt Chart")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openKpiModal(data.item)
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            attrs: { icon: "BarChartIcon" },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "align-middle ml-50",
                                            },
                                            [_vm._v("KPI's")]
                                          ),
                                        ],
                                        1
                                      ),
                                      data.item.status !== "NOTSTARTED" &&
                                      data.item.status !== "REMOVED"
                                        ? _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.viewProjectTestDocument(
                                                    data.item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: {
                                                  icon: "PaperclipIcon",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-50",
                                                },
                                                [_vm._v("Documents")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1191783062
                        ),
                      }),
                      _c(
                        "b-modal",
                        {
                          attrs: {
                            id: "modal-kpi-settings",
                            title: "KPI Settings",
                            centered: "",
                            size: "lg",
                            "ok-title": "Save",
                          },
                          on: { ok: _vm.saveKpiSettings },
                        },
                        [
                          _c(
                            "b-container",
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "KPI Name 1",
                                            "label-for": "kpiName1",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "kpiName1",
                                              type: "text",
                                            },
                                            model: {
                                              value: _vm.project.kpiName1,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.project,
                                                  "kpiName1",
                                                  $$v
                                                )
                                              },
                                              expression: "project.kpiName1",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "KPI Target 1",
                                            "label-for": "kpiTarget1",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "kpiTarget1",
                                              t: "",
                                              type: "number",
                                              min: 0,
                                              step: "0.01",
                                              oninput:
                                                "validity.valid||(value='');",
                                            },
                                            model: {
                                              value: _vm.project.kpiTarget1,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.project,
                                                  "kpiTarget1",
                                                  $$v
                                                )
                                              },
                                              expression: "project.kpiTarget1",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "KPI Value 1",
                                            "label-for": "kpiValue1",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "kpiValue1",
                                              type: "number",
                                              min: 0,
                                              step: "0.01",
                                              oninput:
                                                "validity.valid||(value='');",
                                            },
                                            model: {
                                              value: _vm.project.kpiValue1,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.project,
                                                  "kpiValue1",
                                                  $$v
                                                )
                                              },
                                              expression: "project.kpiValue1",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "KPI Name 2",
                                            "label-for": "kpiName2",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "kpiName2",
                                              ype: "text",
                                            },
                                            model: {
                                              value: _vm.project.kpiName2,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.project,
                                                  "kpiName2",
                                                  $$v
                                                )
                                              },
                                              expression: "project.kpiName2",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "KPI Target 2",
                                            "label-for": "kpiTarget2",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "kpiTarget2",
                                              type: "number",
                                              min: 0,
                                              step: "0.01",
                                              oninput:
                                                "validity.valid||(value='');",
                                            },
                                            model: {
                                              value: _vm.project.kpiTarget2,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.project,
                                                  "kpiTarget2",
                                                  $$v
                                                )
                                              },
                                              expression: "project.kpiTarget2",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "KPI Value 2",
                                            "label-for": "kpiValue2",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "kpiValue2",
                                              type: "number",
                                              min: 0,
                                              step: "0.01",
                                              oninput:
                                                "validity.valid||(value='');",
                                            },
                                            model: {
                                              value: _vm.project.kpiValue2,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.project,
                                                  "kpiValue2",
                                                  $$v
                                                )
                                              },
                                              expression: "project.kpiValue2",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-modal",
                        {
                          attrs: {
                            id: "modal-view-project",
                            "ok-only": "",
                            "ok-title": "View",
                            centered: "",
                            size: "lg",
                            title: "View Project",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("Editproject", {
                            attrs: {
                              project: _vm.currentProject,
                              actionType: "view",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-modal",
                        {
                          attrs: {
                            id: "modal-edit-project",
                            "ok-only": "",
                            "ok-title": "Edit",
                            centered: "",
                            size: "lg",
                            title: "Edit Project",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("Editproject", {
                            attrs: {
                              project: _vm.currentProject,
                              assignee: _vm.assignee_options,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-modal",
                        {
                          ref: "modal-view-testdocument",
                          attrs: {
                            id: "modal-view-testdocument",
                            "ok-only": "",
                            "ok-title": "View",
                            centered: "",
                            size: "lg",
                            title: "View Documents",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("DocumentUpload", {
                            attrs: { documentDetails: _vm.documentDetails },
                            on: {
                              deleteFile: _vm.deleteFile,
                              downloadFile: _vm.downloadFile,
                              uploadFiles: _vm.uploadFiles,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mb-1" },
                    [
                      _vm.loading
                        ? _c("b-spinner", {
                            staticStyle: { width: "3rem", height: "3rem" },
                            attrs: {
                              variant: "success",
                              label: "Spinning",
                              block: "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  !_vm.loading
                    ? _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }